<template lang="pug">
	.monitoring-errors-sql
		.page-center-content
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") Monitoring sql errors log
			.publishers-table
				DataTable(name="monitoring-errors-sql" entity="monitoring_errors_sql" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:monitoring-errors-sql', 'User Actions Log Filters Ready']" :update-if="() => Layout.page === 'monitoring-errors-sql'" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "MonitoringErrorsSQL",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Showed:monitoring-errors-sql", "Publishers Changed"]
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px'
				},
				{
					fieldName: 'code',
					title: 'Error type',
					type: 'string',
					display: true,
					click: this.codeClick,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px',
					displayStyles: () => {return {display: 'block', width: '100px', height: '80px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'message',
					title: 'Error message',
					type: 'string',
					display: true,
					click: this.messageClick,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '300px',
					displayStyles: () => {return {display: 'block', width: '300px', height: '80px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'stack',
					title: 'Call stack',
					type: 'string',
					display: true,
					click: this.stackClick,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '350px',
					displayStyles: () => {return {display: 'block', width: '350px', height: '80px', overflow: 'hidden', textOverflow: 'ellipsis'};}
				},
				{
					fieldName: 'data',
					title: 'Details',
					type: 'button:confirm',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				}
			];

			this.filters = [{
				title: 'Error type',
				field: 'code',
				type: 'in',
				value: '',
				options: [
					{title: '', value: ''},
					{title: 'TypeError', value: 'TypeError'},
					{title: 'ENOENT', value: 'ENOENT'}
				],
				display: true
			}];

			this.buttons = [];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

			},
			codeClick(log) {

				Broadcast.call('Show Confirm', [{
					caption: 'Error type',
					message: log.code,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			},
			messageClick(log) {

				Broadcast.call('Show Confirm', [{
					caption: 'Error type',
					message: log.message,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			},
			stackClick(log) {

				Broadcast.call('Show Confirm', [{
					caption: 'Call stack',
					message: log.stack,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			}
		}
	}
</script>

<style lang="sass" scoped>

	.monitoring-errors-sql
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>

